<template>
    <div class="no__Images">
        <span>Скоро добавим фото объекта</span>
    </div>
</template>

<script>
    export default {
        name: "no-images"
    }
</script>

<style scoped>
    .no__Images {
        display: flex;
        justify-content: center;
        height: 100%;
        background: #ccc;
        align-items: center;

    span {
        text-align: center;
    }
    }
</style>